<template>
    <div class="alert-container">
        <v-alert
        border="bottom"
        colored-border
        elevation="2"
        color="#ea7f1d"
        >
            {{ message }}
        </v-alert>
    </div>
</template>
<script>
import {VAlert} from 'vuetify/lib';
export default {
    components: {VAlert},
    props: {
        message: String
    },
    mounted: function() {
        this.timer = setTimeout(() => {
            this.$el.parentNode.removeChild(this.$el);
        }, 10000);
    },
    beforeDestroy: function() {
        clearTimeout(this.timer);
    }
}
</script>
<style lang="scss" scoped>
.alert-container {
    position: fixed;
    top: 10px;
    left: 20px;
    right: 40px;
    font-family: 'hind';
    z-index: 1000;
}
</style>